<template>
  <div>
    <v-speed-dial
      v-model="fab"
      bottom
      right
      direction="top"
      transition="slide-y-reverse-transition"
      absolute
      fixed
    >
      <template v-slot:activator>
        <v-tooltip color="primary" dark left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-model="fab"
              color="primary"
              dark
              fab
              elevation="0"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon v-if="fab">
                mdi-close
              </v-icon>
              <v-icon large v-else>
                mdi-whatsapp
              </v-icon>
            </v-btn>
          </template>
          <span class="font-general-r">¡Hola!, ¿Cómo podemos ayudarte?</span>
        </v-tooltip>

      </template>
      <v-btn
        style="outline:none !important"
        fab
        dark
        color="primary"
        target="_blank"
        href="https://www.google.com/maps/place/Nieve+de+Olla/@19.4090857,-99.1770353,15z/data=!4m2!3m1!1s0x0:0x115a1e39b117dc00?sa=X&ved=2ahUKEwiHkLGp78LtAhXSzVkKHZGLCI8Q_BIwFnoECCYQBQ"
      >
        <v-icon large>mdi-map-marker</v-icon>
      </v-btn>
      <v-btn
        style="outline:none !important"
        fab
        dark
        color="primary"
        @click="open_modal_phone = true"
      >
        <v-icon large>mdi-phone</v-icon>
      </v-btn>
      <v-btn
        style="outline:none !important"
        fab
        dark
        color="primary"
        target="_blank"
        href="https://wa.me/525579472295"
      >
        <v-icon large>mdi-whatsapp</v-icon>
      </v-btn>
    </v-speed-dial>

    <v-dialog
      v-model="open_modal_phone"
      persistent
      max-width="550"
      transition="dialog-bottom-transition"
    >
      <v-card color="light" class="pr-2 pl-2">

        <v-toolbar
          color="light"
          elevation="0"
        >
          <v-spacer></v-spacer>
          <v-btn
            icon
            small
            @click="open_modal_phone = false"
          >
            <v-icon color="accent">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>

          <div class="flex-center mt-5">
            <div class="text-center">
              <img class="img-cono mb-50" src="@/assets/store/home/cono.png" alt="">
              <h2 class="color-blue font-general-r">Llámanos</h2>
              <h3 class="mt-5 color-blue font-general-r">
                +52 55 7947 2295
              </h3>
            </div>
          </div>

        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data: () => ({
		fab: false,
		open_modal_phone: false
	})
}
</script>
